<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-5>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11>
            <h2>
              <v-icon color="#077893" @click="Fn_BackIndex" size="38"
                >mdi-chevron-left</v-icon
              >{{ $t("policy.text4") }}
            </h2>
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-center align-center pt-5>
          <v-flex xs11 lg11>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-card class="rounded-lg">
                <v-card-title primary-title>
                  {{ $t("policyForm.policyin") }}
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-layout row wrap justify-center align-center pt-2>
                    <v-flex xs11 md11 lg11 block text-left>
                      <b class="red--text mr-2">*</b>
                      <b>{{ $t("policyForm.psps") }}</b> <br />
                      <v-text-field
                        outlined
                        dense
                        color="info"
                        v-model="Title"
                        :label="$t('consentlist.topic')"
                        :rules="[(v) => !!v || $t('policyForm.psps')]"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center align-center pt-2>
                    <v-flex xs11 md11 lg11 pb-4>
                      <b class="red--text mr-1">*</b>
                      <b>{{ $t("policyForm.detail") }}</b>
                      <vue-editor
                        v-model="Detail"
                        :editorToolbar="DefaultToolbar"
                        :rules="[(v) => !!v || $t('policyForm.pspd')]"
                      ></vue-editor>
                    </v-flex>
                    <v-flex xs11 md11 lg11 pb-4>
                      <b v-if="$t('default') === 'th'" class="red--text"
                        >หมายเหตุ :
                        หากบันทึกแล้วจะไม่สามารถแก้ไขข้อมูลนโยบายได้</b
                      >
                      <b v-else class="red--text"
                        >Note: Once saved, the policy information cannot be
                        edited.</b
                      >
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions>
                  <v-layout row wrap justify-center align-center pb-5>
                    <v-flex lg3 md3 xs3 mr-2>
                      <v-btn
                        block
                        dark
                        color="#077893"
                        v-model="Manage"
                        @click="save_draft"
                        :loading="loadingDraft"
                        >{{ $t("policy.text5") }}</v-btn
                      >
                    </v-flex>
                    <v-flex lg3 md3 xs3 v-if="DissabledRole == false">
                      <v-btn
                        block
                        dark
                        color="#077893"
                        v-model="Manage"
                        @click="save_enable"
                        :loading="loadingEnable"
                        >{{ $t("policy.text10") }}</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>
      <div v-if="loadingDownloadData">
        <OverlaySearch :title="ShowTitle" :detail="ShowText" />
      </div>
    </v-main>
  </v-app>
</template>

<script>
import OverlaySearch from "@/components/layouts/LoadingPending.vue";
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import { VueEditor } from "vue2-editor";
import { mapGetters } from "vuex";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: { VueEditor, OverlaySearch },
  data: function () {
    return {
      valid: true,
      ItemPolicy: [],
      Title: "",
      Detail: "",
      Content: "",
      Manage: "",
      Role: [],
      ShowTitle: "โปรดรอสักครู่...",
      ShowText: "ระบบกำลังดำเนินการแจ้งเตือนเพื่อขออนุมัติการสร้างเอกสารนโยบาย",
      DefaultToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
        [{ color: [] }, { size: 56 }, { background: [] }],
      ],
      loadingDownloadData: false,
      DissabledRole: true,
      loadingDraft: false,
      loadingEnable: false,
    };
  },
  computed: {
    ...mapGetters(["Business"]),
    ...mapGetters(["DataPolicy"]),
    ...mapGetters(["RoleAccount"]),
    DataCheckRole: {
      get() {
        return this.$store.state.DataCheckRole;
      },
    },
    _RoleAccount: {
      get() {
        return this.RoleAccount || "-";
      },
    },
    _BusinessName: {
      get() {
        return this.Business.BusinessNameTH || "-";
      },
    },
    _PolicyId: {
      get() {
        return this.DataPolicy.PolicyId || "-";
      },
    },
  },
  mounted() {
    this.Fn_CheckRole();
    this.fn_getDataPolicy();
  },
  methods: {
    async Fn_CheckRole() {
      var payload = {
        TaxId: this.$cookies.get("TaxIdCMP"),
      };

      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };

      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "business/GetBusinessCheckRoleApprove",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            this.Role = response.data.Message.RoleApprove;
            const roleArray = Array.isArray(this.Role)
              ? this.Role
              : [this.Role];
            const roleLowerCase = roleArray.map((role) => role.toLowerCase());

            const dataCheckRoleArray = Array.isArray(this.DataCheckRole)
              ? this.DataCheckRole
              : [this.DataCheckRole];
            const dataCheckRoleLowerCase = dataCheckRoleArray.map((role) =>
              role.toLowerCase()
            );

            const isSimilar = roleLowerCase.some((role) =>
              dataCheckRoleLowerCase.includes(role)
            );
            if (isSimilar === true || this.Role.length === 0) {
              this.DissabledRole = false;
            } else {
              this.DissabledRole = true;
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async fn_getDataPolicy() {
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        PolicyId: this._PolicyId,
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "policy/GetDetailPolicy",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            this.Title = response.data.Message[0].Title;
            this.Detail = response.data.Message[0].Details;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async fn_UpdateDetailPolicy(val) {
      if (this.$refs.form.validate()) {
        this.loadingDownloadData = true;
        var payload = {
          AccountId: this.$cookies.get("OneAccountId"),
          BusinessId: this.$cookies.get("BusinessId"),
          AccessToken: this.$cookies.get("OneAccessToken"),
          PolicyId: this._PolicyId,
          Title: this.Title,
          Details: this.Detail,
          Manage: val,
        };
        var Headers = {
          AccountId: this.$cookies.get("OneAccountId"),
        };
        var dataEncode = await authorization.encodeDataNew(payload);
        var auth = await authorization.encodeDataNew(Headers);
        var headers = { Authorization: "Bearer " + auth };
        this.axios
          .post(
            process.env.VUE_APP_API_FACTORING_SERVICE +
              "policy/UpdateDetailPolicy",
            { Data: dataEncode },
            { headers }
          )
          .then((response) => {
            this.loadingDownloadData = false;
            this.loadingDraft = false;
            this.loadingEnable = false;

            if (response.data.Status === "OK") {
              // this.UpdateDetail = response.data;
              if (val == "draft") {
                Toast.fire({
                  icon: "success",
                  title: this.$i18n.t("policy.text8"),
                });
              } else {
                Toast.fire({
                  icon: "success",
                  title: this.$i18n.t("policy.text9"),
                });
              }
              this.$router.push("/policy-index");
            } else {
              Toast.fire({
                icon: "error",
                title: response.data.ErrorMessage,
              });
            }
          })
          .catch((error) => {
            this.loadingDownloadData = false;
            this.loadingDraft = false;
            this.loadingEnable = false;
            if (error.response) {
              Toast.fire({
                icon: "error",
                title: error.response.data.ErrorMessage,
              });
            } else if (error.request) {
              Toast.fire({
                icon: "error",
                title: error.request,
              });
            } else {
              Toast.fire({
                icon: "error",
                title: error.message || error,
              });
            }
          });
      }
    },
    Fn_BackIndex() {
      this.$router.push("/policy-index");
    },
    async save_draft() {
      this.Manage = "draft";
      var manage = "draft";
      this.loadingDraft = true;
      this.fn_UpdateDetailPolicy(manage);
    },
    async save_enable() {
      this.Manage = "enable";
      var manage = "enable";
      this.loadingEnable = true;
      this.fn_UpdateDetailPolicy(manage);
    },
  },
};
</script>

<style>
td {
  border-style: hidden !important;
}
</style>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}
</style>
